import { AuthenticatedUser } from '../../domain/auth';
import { authService } from '../../services/authService';
import { logger } from '../../services/logger';
import { useFeedback } from '../feedback/FeedbackProvider';

export function usePasswordChange(user: AuthenticatedUser | null) {
  const { notify } = useFeedback();
  const changePassword = async (
    currentPassword: string,
    newPassword: string,
  ) => {
    if (!user?.email) {
      notify('You must be logged in to change your password.', 'error');
      return;
    }
    try {
      await authService.changePassword(user, currentPassword, newPassword);
    } catch (error) {
      logger.error('Error changing password:', error);
      const message = error instanceof Error ? error.message : '';
      if (
        message.includes('auth/wrong-password') ||
        message.includes('auth/invalid-credential')
      ) {
        notify('Current password is incorrect. Please try again.', 'error');
      } else if (message.includes('auth/weak-password')) {
        notify(
          'New password is too weak. Please use a stronger password.',
          'error',
        );
      } else {
        notify('Failed to change password. Please try again.', 'error');
      }
    }
  };

  return changePassword;
}
